export function renderHome(container: HTMLElement): void {
  container.innerHTML = `
    <main class="container">
      <h1>Curate — Partner onboarding</h1>
      <p>This tool helps you set up your business profile in the Curate app.</p>
      <ul class="route-list">
        <li>Already listed with us? <a href="#/claim">Claim your business</a> — you'll need the
          code or QR from John, or the email address we hold for you.</li>
        <li>New here? <a href="#/apply">Get listed on Curate</a></li>
        <li>Already set up? <a href="#/edit">Edit your profile</a> (you'll be prompted to sign in)</li>
      </ul>
      <p class="footer-note">Curate is operated by E-Bikes Florence. Questions? Email john@ebikesflorence.com.</p>
    </main>
  `;
}
